import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

let columnsData = [
  {
    field: "school_name",
    headerName: "School Name",
    flex: 1,
    minWidth: 140,
  },
  {
    field: "school_id",
    headerName: "School Id",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "school_address",
    headerName: "Address",
    flex: 1,
    minWidth: 160,
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 100,
      maxWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Edit school"
              onClick={() => {
                setOpen(true);
                setSelectedRow(params.row);
              }}
            >
              <EditRoundedIcon fontSize="small" />
            </ActionIconButton>
            <ActionIconButton
              title="Delete school"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
